module.exports = __webpack_public_path__ + "media/images/demo/m_site_template/O36H7QI1-e05db66be425098a345e078015792e7f.png";